import classNames from 'clsx'

import { useGetAvailabilityTranslation } from 'views/components/organisms/Cart/ProductInfo/hooks/useGetAvailabilityTranslation'

// @ts-ignore
const AvailabilityStatus = ({
  available,
  productType,
  isMarketplaceProduct,
  deliveryTime,
}: {
  available: boolean
  productType: string
  isMarketplaceProduct: boolean
  deliveryTime?: { earliestDays?: number; latestDays?: number } | null
}) => {
  const contentToRender = useGetAvailabilityTranslation({
    available,
    productType,
    isMarketplaceProduct,
    deliveryTime,
  })

  return (
    <div
      className={classNames(
        {
          'u-color--positive o-ProductInfo__availability-available': available,
          'u-color--info-dark o-ProductInfo__availability-not-available':
            !available,
        },
        'u-font-weight--bold o-ProductInfo__availability'
      )}
    >
      {contentToRender}
    </div>
  )
}

export default AvailabilityStatus
